import lazyRetry from '../helpers/lazyRetry';
import { Constant } from '../Containers/Helpers/constant';
import { applyDomainRouteAliases } from './domainConfig';

const Dashboard = lazyRetry(() => import('./../Containers/Pages/index').then(m => ({ default: m.Dashboard })));
const Login = lazyRetry(() => import('./../Containers/Pages/index').then(m => ({ default: m.Login })));
const Home = lazyRetry(() => import('./../Containers/Pages/index').then(m => ({ default: m.Home })));

const Logout = lazyRetry(() => import('../pages/Authentication/Logout'));

/* ---------------------------- SUPPLY STORE ---------------------------- */
const UploadStatus = lazyRetry(() => import('./../Containers/Pages/SupplyStore/UploadStatus/index'));
const AddCategory = lazyRetry(() => import('../Containers/Pages/SupplyStore/Category/AddCategory'));
const ManageCategory = lazyRetry(() => import('../Containers/Pages/SupplyStore/Category/ManageCategory'));
const AddLocation = lazyRetry(() => import('../Containers/Pages/SupplyStore/Location/AddLocation'));
const ManageLocation = lazyRetry(() => import('../Containers/Pages/SupplyStore/Location/ManageLocation'));
const LocationBlockDateManagement = lazyRetry(() => import('../Containers/Pages/SupplyStore/Location/BlockDate'));
const AddPartner = lazyRetry(() => import('../Containers/Pages/SupplyStore/Partner/AddPartner'));
const ManagePartner = lazyRetry(() => import('../Containers/Pages/SupplyStore/Partner/ManagePartner'));
const AddService = lazyRetry(() => import('../Containers/Pages/SupplyStore/Service/AddService'));
const ManageService = lazyRetry(() => import('../Containers/Pages/SupplyStore/Service/ManageService'));

/* ----------------------------------- COMMUNCATION MANAGEMENT ----------------------------------- */
const AddTemplateEngine = lazyRetry(() => import('../Containers/Pages/Communication/TemplateEngine/AddTemplateEngine'));
const ManageTemplateEngine = lazyRetry(() => import('../Containers/Pages/Communication/TemplateEngine/ManageTemplateEngine'));

/* ----------------------------------- COUPON MANAGEMENT ----------------------------------- */
// import {
//   StaticCouponManagement,
//   UniqueCouponManagement,
// } from "../Containers/Pages/Coupon";
// import { StaticCouponManagement, UniqueCouponManagement } from "../Containers/Pages/Coupon";
const StaticCouponManagement = lazyRetry(() => import('./../Containers/Pages/Coupon/Components/StaticCoupon/index'));
const UniqueCouponManagement = lazyRetry(() => import('./../Containers/Pages/Coupon/Components/UniqueCoupon/index'));

/* ----------------------------------- CUSTOMER MANAGEMENT ----------------------------------- */
const CustomerManagement = lazyRetry(() => import('../Containers/Pages/CustomerManagement'));

/* ----------------------------------- CUSTOMER DATA MANAGEMENT ----------------------------------- */
const CustomerDataManagement = lazyRetry(() => import('../Containers/Pages/CustomerDataManagement'));

/* ----------------------------------- DUPLICATE CARDS MANAGEMENT ----------------------------------- */
const DuplicateCardsManagement = lazyRetry(() => import('../Containers/Pages/DuplicateCardsManagement'));

/* ----------------------------------- BENEFIT MANAGEMENT ----------------------------------- */
const BenefitPacksManagement = lazyRetry(() =>
  import('./../Containers/Pages/BenefitManagement/index').then(m => ({ default: m.BenefitPacksManagement })),
);
const BenefitGroupsManagement = lazyRetry(() =>
  import('./../Containers/Pages/BenefitManagement/index').then(m => ({ default: m.BenefitGroupsManagement })),
);

/* ----------------------------------- CONFIG STORE MANAGEMENT ----------------------------------- */
const CatalogueManagement = lazyRetry(() => import('./../Containers/Pages/ConfigStore/index').then(m => ({ default: m.CatalogueManagement })));

/* ----------------------------------- BOOKING MANAGEMENT ----------------------------------- */
const GolfBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/Golf/index'));
const UniqueCouponBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/UniqueCoupon/index'));
const StaticCouponBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/StaticCoupon/index'));
const InsuranceBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/Insurance/index'));
const LocalCourierBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/LocalCourier/index'));
const MeetAndGreetBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/MeetAndGreet/index'));
const PickAndDropBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/PickAndDrop/index'));
const QRBookingManagement = lazyRetry(() => import('./../Containers/Pages/BookingsManagement/Components/QR/index'));
const CarServicingBookingManagement = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/CarServicing'));
const CarRegistrationBookingManagement = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/CarRegistration'));
const ThriwePrimeBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/ThriwePrimeBooking/index'));
const DynamicQrBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/DynamicQr/index'));
/* ----------------------------------- DOWNLOAD ----------------------------------- */
const ClientDownloadsV2 = lazyRetry(() => import('../Containers/Pages/Client/DownloadsV2'));
const ClientCustomerManagement = lazyRetry(() => import('../Containers/Pages/CustomerManagement/ClientCustomerManagement'));
const Downloads = lazyRetry(() => import('../Containers/Pages/Downloads'));
const ChauffeurOverview = lazyRetry(() => import('../Containers/Pages/v2/ChauffeurManagement').then(m => ({ default: m.ChauffeurOverview })));
const VehicleManagement = lazyRetry(() => import('../Containers/Pages/v2/VehicleManagement').then(m => ({ default: m.VehicleOverview })));
const ChauffeurOverviewV2 = lazyRetry(() => import('../Containers/Pages/v2/ChauffeurManagementV2').then(m => ({ default: m.ChauffeurOverview })));

/* ----------------------------------- RULES MANAGEMENT ----------------------------------- */
const EventManagement = lazyRetry(() => import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.EventManagement })));
const ExpenditureManagement = lazyRetry(() =>
  import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.ExpenditureManagement })),
);
const LedgerV2 = lazyRetry(() => import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.LedgerV2 })));
const Referral = lazyRetry(() => import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.Referral })));
const ServiceWorthManagement = lazyRetry(() =>
  import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.ServiceWorthManagement })),
);
const FileUpload = lazyRetry(() => import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.FileUpload })));
const Voucher = lazyRetry(() => import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.Voucher })));
const AnnoucementForGlobeToyota = lazyRetry(() =>
  import('./../Containers/Pages/RulesManagement/index').then(m => ({ default: m.AnnoucementForGlobeToyota })),
);
const CourseWiseFormats = lazyRetry(() => import('../Containers/Pages/GolfAdminRealTime').then(m => ({ default: m.CourseWiseFormats })));
const EditCourseFormats = lazyRetry(() => import('../Containers/Pages/GolfAdminRealTime').then(m => ({ default: m.EditCourseFormats })));
const RealTimeSlotsReport = lazyRetry(() => import('../Containers/Pages/GolfAdminRealTime').then(m => ({ default: m.RealTimeSlotsReport })));
const SlotUnavailability = lazyRetry(() => import('../Containers/Pages/GolfAdminRealTime').then(m => ({ default: m.SlotUnavailability })));

/* ----------------------------------- USER MANAGEMENT ----------------------------------- */
const UserManagement = lazyRetry(() => import('../Containers/Pages/UserManagement'));

/* ----------------------------------- PROJECT MANAGEMENT ----------------------------------- */
const PaymentLogs = lazyRetry(() => import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.PaymentLogs })));
const ProjectPaymentsSettings = lazyRetry(() =>
  import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.ProjectPaymentsSettings })),
);
const Clients = lazyRetry(() => import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.Clients })));
const DataIntegration = lazyRetry(() => import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.DataIntegration })));
const Program = lazyRetry(() => import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.Program })));
const Platform = lazyRetry(() => import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.Platform })));
const ProjectComs = lazyRetry(() => import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.ProjectComs })));
const ProgramOnboarding = lazyRetry(() => import('../Containers/Pages/ProjectsManagement/index').then(m => ({ default: m.ProgramOnboarding })));

const CustomDownload = lazyRetry(() => import('../Containers/Pages/CustomDownloadsManagement/CustomDownload'));
const Campaigns = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.Campaigns })));
const Communication = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.Communication })));
const Events = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.Events })));
const Ledger = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.Ledger })));
const Rules = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.Rules })));
const RulesList = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.RulesList })));
const SurgeEvent = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.SurgeEvent })));
const SurgeWorkflow = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.SurgeWorkflow })));
const Wallet = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.Wallet })));
const SurgeDashboard = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.SurgeDashboard })));
const ConfigurationMapping = lazyRetry(() => import('../Containers/Pages/SurgeSphere').then(m => ({ default: m.ConfigurationMapping })));
const WorkflowManagement = lazyRetry(() => import('../Containers/Pages/SupplyStore/Category/Workflow'));
const DataPool = lazyRetry(() => import('../Containers/Pages/DataPool'));
const ClientDynamicBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement').then(m => ({ default: m.ClientDynamicBooking })));
const ClientGamificationBooking = lazyRetry(() =>
  import('../Containers/Pages/BookingsManagement').then(m => ({ default: m.ClientGamificationBooking })),
);
const ClientUniqueBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement').then(m => ({ default: m.ClientUniqueBooking })));
const DiningBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement').then(m => ({ default: m.DiningBooking })));
const HireADriverBookingManagement = lazyRetry(() =>
  import('../Containers/Pages/BookingsManagement').then(m => ({ default: m.HireADriverBookingManagement })),
);
const ValetParkingManagement = lazyRetry(() => import('../Containers/Pages/BookingsManagement').then(m => ({ default: m.ValetParkingManagement })));
const ServiceBlockDateManagement = lazyRetry(() => import('../Containers/Pages/SupplyStore/Service/BlockDate'));
const ClubBookingManagement = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/Club'));
const AirportTransfer = lazyRetry(() => import('../Containers/Pages/InventoryManagement').then(m => ({ default: m.AirportTransfer })));
const CommsReport = lazyRetry(() => import('../Containers/Pages/Reports').then(m => ({ default: m.CommsReport })));
const ClientLogin = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.ClientLogin })));
const ResetPassword = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.ResetPassword })));
const ClientForgotPassword = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.ClientForgotPassword })));
const History = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.History })));
const AirportTransferManualBooking = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.AirportTransferManualBooking })));
const MeetAndGreetManualBooking = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.MeetAndGreetManualBooking })));
const ContactUs = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.ContactUs })));
const ClientDownloads = lazyRetry(() => import('../Containers/Pages/Client').then(m => ({ default: m.ClientDownloads })));
const VendorAirportTransfer = lazyRetry(() => import('../Containers/Pages/VendorPanel/Enbd').then(m => ({ default: m.VendorAirportTransfer })));
const VendorDownloads = lazyRetry(() => import('../Containers/Pages/VendorPanel/Enbd').then(m => ({ default: m.VendorDownloads })));
const QRPage = lazyRetry(() => import('../Containers/Pages/VendorPanel/ValetParking').then(m => ({ default: m.QRPage })));
const VendorBookingValetParking = lazyRetry(() =>
  import('../Containers/Pages/VendorPanel/ValetParking').then(m => ({ default: m.VendorBookingValetParking })),
);
const VendorReport = lazyRetry(() => import('../Containers/Pages/VendorPanel/ValetParking').then(m => ({ default: m.VendorReport })));
const VendorLogin = lazyRetry(() => import('../Containers/Pages/VendorPanel/Login'));
const VendorPanelDashboard = lazyRetry(() => import('../Containers/Pages/VendorPanel/Comman/Dashboard'));
const DelayedCouponBookingManagement = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/DelayedCoupon'));
const GenerateVoucher = lazyRetry(() => import('../Containers/Pages/Client/Landmark').then(m => ({ default: m.GenerateVoucher })));
const ReportLandmark = lazyRetry(() => import('../Containers/Pages/Client/Landmark').then(m => ({ default: m.ReportLandmark })));
const CarterXBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/CarterxBooking'));
const VendorDiningBooking = lazyRetry(() => import('../Containers/Pages/VendorPanel/ThriweDining').then(m => ({ default: m.VendorDiningBooking })));

/* ----------------------------------- BOOKING MANAGEMENT V2 ----------------------------------- */
const DelayedBookingV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/DelayedBooking'));
const UniqueCouponV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/UniqueCoupon'));
const StaticCouponV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/StaticCoupon'));
const PickAndDropBookingManagementV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/PickAndDrop'));
const QRBookingManagementV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/QR'));
const Feedback = lazyRetry(() => import('../Containers/Pages/Review').then(m => ({ default: m.Feedback })));
const Query = lazyRetry(() => import('../Containers/Pages/Review').then(m => ({ default: m.Query })));
const GolfBookingManagementV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/Golf'));
const CustomDelayedBookingV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/CustomDelayedBooking'));

const benefitPackDownloadPermission = lazyRetry(() => import('../Containers/Pages/benefitPackDownloadPermission'));
const BusinessRegistration = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.BusinessRegistration })));
const Offers = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.Offers })));
const Posts = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.Posts })));
const Annoucements = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.Annoucements })));
const ClientCustomers = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.ClientCustomers })));
const ClientGolfBooking = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.ClientGolfBooking })));
const ClientUniqueCouponBooking = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.ClientUniqueCouponBooking })));
const ClientBookingsDownloads = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.ClientBookingsDownloads })));
const UserManagementAdib = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.UserManagementAdib })));
const AdibDashboard = lazyRetry(() => import('../Containers/Pages/Client/Adib').then(m => ({ default: m.AdibDashboard })));
const BookingSearch = lazyRetry(() => import('../Containers/Pages/BookingSearch'));
const CustomerDownloads = lazyRetry(() => import('../Containers/Pages/CustomerDownloads'));

/* ----------------------------------- GM REPORT ----------------------------------- */
const DynamicCouponBookingManagement = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Components/DynamicCoupon'));
const BookingRecon = lazyRetry(() => import('../Containers/Pages/SupplyStore/GmReport').then(m => ({ default: m.BookingRecon })));
const ClientPricing = lazyRetry(() => import('../Containers/Pages/SupplyStore/GmReport').then(m => ({ default: m.ClientPricing })));
const GmReport = lazyRetry(() => import('../Containers/Pages/SupplyStore/GmReport').then(m => ({ default: m.GmReport })));
const MasterUploads = lazyRetry(() => import('../Containers/Pages/SupplyStore/GmReport').then(m => ({ default: m.MasterUploads })));
const PriceViewer = lazyRetry(() => import('../Containers/Pages/SupplyStore/GmReport').then(m => ({ default: m.PriceViewer })));
const DynamicCouponV2 = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/DynamicCoupon'));
const RoleSelection = lazyRetry(() => import('../Containers/Pages/v2/RoleSelection'));
const LoginV2 = lazyRetry(() => import('../Containers/Pages/LoginV2'));
const VendorLoginV2 = lazyRetry(() => import('../Containers/Pages/VendorLogin/Login'));
const BookingDashboard = lazyRetry(() => import('../Containers/Pages/v2').then(m => ({ default: m.BookingDashboard })));
const DashboardV2 = lazyRetry(() => import('../Containers/Pages/v2').then(m => ({ default: m.DashboardV2 })));
const ProgramManagement = lazyRetry(() => import('../Containers/Pages/v2').then(m => ({ default: m.ProgramManagement })));
const CompaignManagement = lazyRetry(() => import('../Containers/Pages/v2').then(m => ({ default: m.CompaignManagement })));
const CsatVerticalDashboard = lazyRetry(() => import('../Containers/Pages/v2').then(m => ({ default: m.CsatVerticalDashboard })));
const CsatProgramWiseDashboard = lazyRetry(() => import('../Containers/Pages/v2').then(m => ({ default: m.CsatProgramWiseDashboard })));
const CloudPainMinutesDashboard = lazyRetry(() => import('../Containers/Pages/v2').then(m => ({ default: m.CloudPainMinutesDashboard })));
const VendorDashboardV2 = lazyRetry(() => import('../Containers/Pages/v2/VendorDashboard'));
const UserDownloads = lazyRetry(() => import('../Containers/Pages/Client/Adib/Components/UserDownloads'));
const DynamicReason = lazyRetry(() => import('../Containers/Pages/v2/DynamicReason'));
const GlobalSearchBooking = lazyRetry(() => import('../Containers/Pages/v2/GlobalSearch'));
const BookingDownloads = lazyRetry(() => import('../Containers/Pages/BookingDownloads'));
const DownloadReportsV2 = lazyRetry(() => import('../Containers/Pages/v2/DownloadReports'));
const AirportTransferBookingV2 = lazyRetry(() => import('../Containers/Pages/v2/Bookings'));
const Notification = lazyRetry(() => import('../Containers/Pages/v2/Notification'));
const PaddleBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/PaddleBooking'));
const VascoBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/VacoBooking'));
const ApprovalListing = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.ApprovalListing })));
const ClientPricingV2 = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.ClientPricingV2 })));
const InventoryAirportDashboard = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.InventoryAirportDashboard })));
const InventoryList = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.InventoryList })));
const InventoryOverView = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.InventoryOverView })));
const PendingApprovals = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.PendingApprovals })));
const SavedConfiguration = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.SavedConfiguration })));
const VendorPricing = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.VendorPricing })));
const InventoryGolfDashboard = lazyRetry(() => import('../Containers/Pages/v2/Pricing').then(m => ({ default: m.InventoryGolfDashboard })));
const ClientCustomerDownloadsV2 = lazyRetry(() => import('../Containers/Pages/Client/CustomerDownloadsV2'));
const Gamification = lazyRetry(() => import('../Containers/Pages/RulesManagement/v2/Gamification'));
const FeedbackGlobeToyota = lazyRetry(() => import('../Containers/Pages/RulesManagement/v2/Feedback'));
const LadiesClubBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/LadiesClubBooking'));
const MeetGreetBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/MeetGreetBoking'));
const Customer360 = lazyRetry(() => import('../Containers/Pages/v2/Customer360'));
const Customer360V2 = lazyRetry(() => import('../Containers/Pages/v2/Customer360V2'));
const TicketConfiguration = lazyRetry(() => import('../Containers/Pages/v2/TicketManagement').then(m => ({ default: m.TicketConfiguration })));
const TicketSummary = lazyRetry(() => import('../Containers/Pages/v2/TicketManagement').then(m => ({ default: m.TicketSummary })));
const TicketListing = lazyRetry(() => import('../Containers/Pages/v2/TicketManagement/Components/Listing'));
const RegisterNewUser360 = lazyRetry(() => import('../Containers/Pages/v2/Customer360/Components/RegisterNewUser360'));
const CustomerSummary = lazyRetry(() => import('../Containers/Pages/v2/Customer360/Components/CustomerSummary'));
const CompaignListing = lazyRetry(() => import('../Containers/Pages/v2/CampaignManagement/Listing'));
const CreateCampaign = lazyRetry(() => import('../Containers/Pages/v2/CampaignManagement/CreateCampaign'));
const ResetChauffeurPassword = lazyRetry(() => import('../Containers/Pages/ResetPassword'));

const DigitalInventoryDashboard = lazyRetry(() => import('../Containers/Pages/v2/Pricing/Inventory/Components/DigitalDashboard'));
const DigitalBookingManagement = lazyRetry(() => import('../Containers/Pages/v2/DigitalBookingManagement'));
const OutletManagement = lazyRetry(() => import('../Containers/Pages/v2/OutletManagement').then(m => ({ default: m.OutletManagement })));
const ValidationManagement = lazyRetry(() => import('../Containers/Pages/v2/ValidationManagement').then(m => ({ default: m.ValidationManagement })));
const CustomerCallbackQueue = lazyRetry(() => import('../Containers/Pages/v2/Customer360/Components/CallbackQueue'));
const SupplyDataListing = lazyRetry(() => import('../Containers/Pages/v2/Pricing/Inventory').then(m => ({ default: m.SupplyDataListing })));
const GMDashboardChart = lazyRetry(() => import('../Containers/Pages/v2/GMDashboard').then(m => ({ default: m.GMDashboardChart })));
const GMGaps = lazyRetry(() => import('../Containers/Pages/v2/GMGaps').then(m => ({ default: m.GMGaps })));
const GMGapsBookingDetail = lazyRetry(() => import('../Containers/Pages/v2/GMGaps').then(m => ({ default: m.GMGapsBookingDetail })));
const ValetBooking = lazyRetry(() => import('../Containers/Pages/BookingsManagement/Booking_V2/Components/ValetBooking'));
const ClientLoginV2 = lazyRetry(() => import('../Containers/Pages/ClientLoginV2/Login'));
const ClientDashboardV2 = lazyRetry(() => import('../Containers/Pages/v2/ClientDashboard'));
const V2ClientResetPassword = lazyRetry(() => import('../Containers/Pages/ClientLoginV2').then(m => ({ default: m.V2ClientResetPassword })));
const V2ClientForgotPassword = lazyRetry(() => import('../Containers/Pages/ClientLoginV2/ForgotPassword'));
const ClientPanelUser = lazyRetry(() => import('../Containers/Pages/v2/ClientPanelUser'));
const DownloadReportsClientV2 = lazyRetry(() => import('../Containers/Pages/v2/DownloadReportsClient'));
const CustomerReportsClientV2 = lazyRetry(() => import('../Containers/Pages/v2/CustomerReportsClient'));
const ClientDashboardComingSoon = lazyRetry(() => import('../Containers/Pages/ClientDashboardComingSoon'));
const CreateProgram = lazyRetry(() => import('../Containers/Pages/v2/ProgramManagement/CreateProgram'));
const ProgramManagementDashboard = lazyRetry(() => import('../Containers/Pages/v2/ProgramManagement/Dashboard'));
const SupersetCanvasDashboard = lazyRetry(() => import('../Containers/Pages/v2/ClientSupersetDashboard'));
const SupersetCanvasViewer = lazyRetry(() => import('../Containers/Pages/v2/ClientSupersetDashboard/Viewer'));
const ProgramManagementDashboardDetails = lazyRetry(() => import('../Containers/Pages/v2/ProgramManagement/DashboardDetails'));
const AirportVendorDashboard = lazyRetry(() => import('../Containers/Pages/v2/ProgramManagement/DashboardDetails/VendorDashboard'));
const PainMinutesDashboard = lazyRetry(() => import('../Containers/Pages/v2/ProgramManagement/PainMinutesDashboard'));
const GmInventorySaas = lazyRetry(() => import('../Containers/Pages/v2/GmInventorySaas'));
const CreateSaas = lazyRetry(() => import('../Containers/Pages/v2/GmInventorySaas/CreateSaas'));
const CreateOfferManagement = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryOfferManagement/CreateOfferManagement'));
const CreateHyperlocal = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryHyperlocal/CreateHyperlocal'));
const GmInventoryOfferManagement = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryOfferManagement'));
const GmInventoryHyperlocal = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryHyperlocal'));
const GmInventoryEvents = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryEvents'));
const CreateEvents = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryEvents/CreateEvents'));
const GmInventoryDigital = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryDigital'));
const CreateDigital = lazyRetry(() => import('../Containers/Pages/v2/GmInventoryDigital/CreateDigital'));
const QuotaReversal = lazyRetry(() => import('../Containers/Pages/v2/QuotaReversal'));
const CreateQuotaReversalRequest = lazyRetry(() => import('../Containers/Pages/v2/QuotaReversal/CreateRequest'));
const ClientLoginV2VerifyOtp = lazyRetry(() => import('../Containers/Pages/ClientLoginV2/Login/VerifyOtp'));
const CompaignManagementFabSurge = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.CompaignManagementFabSurge })));
const ManageCompaign = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.ManageCompaign })));
const RulesManagementFabSurge = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.RulesManagementFabSurge })));
const UserManagementV2 = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.UserManagementV2 })));
const TemplateManagement = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.TemplateManagement })));
const ManageTemplate = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.ManageTemplate })));
const FabSurgeLedger = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.FabSurgeLedger })));
const DataUploadManagement = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.DataUploadManagement })));
const UploadDataFile = lazyRetry(() => import('../Containers/Pages/v2/Fab-Surge').then(m => ({ default: m.UploadDataFile })));

/* ----------------------------------- INVENTORY SETTINGS ----------------------------------- */
let variable = 'landmark';
const publicRoutes = [
  { path: '/login-v2', component: LoginV2 },
  { path: '/v2/vendor/login', component: VendorLoginV2 },
  { path: '/v2/client/login', component: ClientLoginV2 },
  { path: '/v2/client/verify-otp', component: ClientLoginV2VerifyOtp },
  { path: '/role-selection', component: RoleSelection },

  { path: '/login', component: Login },
  { path: '/logout', component: Logout },

  { path: '/maker-checker', component: benefitPackDownloadPermission },

  // Client routes
  { path: `/client/:clientId/login`, component: ClientLogin },
  { path: `/client/login`, component: ClientLogin },
  { path: '/client/forgot-password', component: ClientForgotPassword },
  { path: '/client/reset-password', component: ResetPassword },
  { path: '/v2/client/forgot-password', component: V2ClientForgotPassword },
  { path: '/v2/client/reset-password', component: V2ClientResetPassword },
  { path: '/reset-password', component: ResetChauffeurPassword },

  // Vendor routes
  { path: '/vendor/login', component: VendorLogin },
];

const authV2ProtectedRoutes = [
  { path: '/', component: Home },
  { path: '/v2/dashboard', component: ProgramManagementDashboard },
  // { path: '/v2/dashboard', component: DashboardV2 },
  { path: '/v2/bookings', component: DashboardV2 },
  { path: '/v2/booking-dashboard', component: BookingDashboard },
  { path: '/v2/booking', component: AirportTransferBookingV2 },
  { path: '/v2/vendor-dashboard', component: VendorDashboardV2 },
  { path: '/v2/client-dashboard', component: ClientDashboardV2 },
  // { path: '/v2/client-dashboard', component: ClientDashboardComingSoon },
  { path: '/v2/global-search-booking', component: GlobalSearchBooking },
  { path: '/v2/notifications', component: Notification },
  { path: '/v2/dynamic-reason', component: DynamicReason },
  { path: '/v2/download-reports', component: DownloadReportsV2 },
  { path: '/v2/program-onboarding', component: ClientPricingV2 },
  { path: '/v2/inventory-overview', component: InventoryOverView },
  { path: '/v2/download-reports-client', component: DownloadReportsClientV2 },
  { path: '/v2/customer-reports-client', component: CustomerReportsClientV2 },
  { path: '/v2/inventory-dashboard/airport', component: InventoryAirportDashboard },
  { path: '/v2/inventory-dashboard/golf', component: InventoryGolfDashboard },
  { path: '/v2/inventory-dashboard/digital', component: DigitalInventoryDashboard },
  { path: '/v2/inventory-list', component: InventoryList },
  { path: '/v2/supply-data-list', component: SupplyDataListing },
  { path: '/v2/pending-approvals', component: PendingApprovals },
  { path: '/v2/approvals-listing', component: ApprovalListing },
  { path: '/v2/saved-configuration', component: SavedConfiguration },
  { path: '/v2/vendor-onboarding', component: VendorPricing },
  { path: '/v2/customer-manual-search', component: Customer360 },
  { path: '/v2/customer-manual-search-v2', component: Customer360V2 },
  { path: '/v2/client-panel-user', component: ClientPanelUser },
  // { path: '/v2/client-panel-user', component: ClientDashboardComingSoon },
  { path: '/v2/ticket-management', component: TicketSummary },
  { path: '/v2/ticket-configuration', component: TicketConfiguration },
  { path: '/v2/tickets', component: TicketListing },
  { path: '/v2/digital-booking-management', component: DigitalBookingManagement },
  { path: '/v2/digital-outlet-management', component: OutletManagement },
  { path: '/v2/digital-validation-management', component: ValidationManagement },
  { path: '/v2/campaigns-management', component: CompaignManagement },
  { path: '/v2/campaign-listing', component: CompaignListing },
  { path: '/v2/create-campaign', component: CreateCampaign },
  { path: '/v2/pricing/saas', component: GmInventorySaas },
  { path: '/v2/create-saas-entry', component: CreateSaas },
  { path: '/v2/create-offer-management', component: CreateOfferManagement },
  { path: '/v2/pricing/offer-management', component: GmInventoryOfferManagement },
  { path: '/v2/pricing/hyperlocal', component: GmInventoryHyperlocal },
  { path: '/v2/create-hyperlocal', component: CreateHyperlocal },
  { path: '/v2/pricing/events', component: GmInventoryEvents },
  { path: '/v2/create-events-entry', component: CreateEvents },
  { path: '/v2/pricing/digital', component: GmInventoryDigital },
  { path: '/v2/create-digital-entry', component: CreateDigital },
  { path: '/v2/utility-request-dashboard', component: QuotaReversal },
  { path: '/v2/utility-request-dashboard/create', component: CreateQuotaReversalRequest },

  // Program management
  { path: '/v2/program-management', component: ProgramManagement },
  { path: '/v2/program-management/create-program', component: CreateProgram },
  { path: '/v2/program-management/update-program', component: CreateProgram },
  { path: '/v2/program-management/dashboard', component: ProgramManagementDashboard },
  { path: '/v2/program-management/dashboard/details', component: ProgramManagementDashboardDetails },
  { path: '/v2/program-management/dashboard/details/vendor', component: AirportVendorDashboard },
  { path: '/v2/program-management/csat/dashboard', component: CsatVerticalDashboard },
  { path: '/v2/program-management/csat/program-wise', component: CsatProgramWiseDashboard },
  { path: '/v2/program-management/dashboard/pain-minutes', component: PainMinutesDashboard },
  { path: '/v2/program-management/pain-minutes/cloud-pain-minutes', component: CloudPainMinutesDashboard },

  { path: '/v2/ticket-management/list/unassigned', component: TicketListing },
  { path: '/v2/ticket-management/list/all-pending', component: TicketListing },
  { path: '/v2/ticket-management/list/all-complete', component: TicketListing },
  { path: '/v2/ticket-management/list/assigned-to-me', component: TicketListing },
  { path: '/v2/ticket-management/list/created-by-me', component: TicketListing },
  { path: '/v2/ticket-management/list/completed-by-me', component: TicketListing },
  { path: '/v2/customer-callback-queue', component: CustomerCallbackQueue },

  // Temporary route for ticket listing
  { path: '/v2/ticket-management/list', component: TicketListing },
  { path: '/v2/register-user-360', component: RegisterNewUser360 },
  { path: '/v2/chauffeur-overview', component: ChauffeurOverview },
  { path: '/v3/chauffeur-overview', component: ChauffeurOverviewV2 },
  { path: '/v2/vehicle-overview', component: VehicleManagement },
  { path: '/v2/customer-summary', component: CustomerSummary },
  { path: '/v2/gm-dashboard', component: GMDashboardChart },

  // Superset canvas — drag-and-drop layout builder + layout viewer
  { path: '/v2/superset-canvas', component: SupersetCanvasDashboard },
  { path: '/v2/superset-canvas/view', component: SupersetCanvasViewer },

  { path: '/v2/gm-dashboard/gm-gaps', component: GMGaps },
  { path: '/v2/gm-dashboard/gm-gaps/bookings', component: GMGapsBookingDetail },

  // FAB SURGE
  { path: '/v2/campaign-management', component: CompaignManagementFabSurge },
  { path: '/v2/compaign/manage', component: ManageCompaign },
  { path: '/v2/rule-management', component: RulesManagementFabSurge },
  { path: '/v2/user-management', component: UserManagementV2 },
  { path: '/v2/template-management', component: TemplateManagement },
  { path: '/v2/template/manage', component: ManageTemplate },
  { path: '/v2/ledger', component: FabSurgeLedger },
  { path: '/v2/data-management', component: DataUploadManagement },
  { path: '/v2/data-management/upload', component: UploadDataFile },
];

const authProtectedRoutes = [
  { path: '/dashboard', component: Dashboard },
  { path: '/', component: Home },

  // Client routes
  {
    path: '/client/dashboard',
    component: Constant?.PROJECT_CODE === 'ADIB_V2' ? AdibDashboard : Dashboard,
    ...(Constant?.PROJECT_CODE === 'ADIB_V2' && { name: 'ADIB_READ' }), // Add extra key only if ADIB_V2
  },
  { path: '/client/login', component: Home },

  // LANDMARK CLIENT routes
  { path: `/client/login/:clientId`, component: ClientLogin, name: 'Login' },
  { path: '/client/voucher-generate', component: GenerateVoucher, name: 'GENERATE_VOUCHER' },
  { path: '/client/voucher-bookings', component: ReportLandmark, name: 'VOUCHERS_REPORT' },

  /* ---------------------------- COMMUNICATION ---------------------------- */
  // TEMPLATE ENGINE
  {
    path: '/template-engine/add-template-engine',
    component: AddTemplateEngine,
    name: 'TEMPLATE_ENGINE_CREATE',
  },
  {
    path: '/template-engine/manage-template-engine',
    component: ManageTemplateEngine,
    name: 'TEMPLATE_ENGINE_READ',
  },

  /* ---------------------------- BLOCK DATES MANAGEMENT ---------------------------- */
  {
    path: '/block-dates',
    component: LocationBlockDateManagement,
    name: 'BLOCK_DATE_MANAGEMENT',
  },

  /* ---------------------------- SUPPLY STORE ---------------------------- */
  // CATEGORY
  {
    path: '/category/add-category',
    component: AddCategory,
    name: 'CATEGORY_CREATE',
  },
  {
    path: '/category/manage-category',
    component: ManageCategory,
    name: 'CATEGORY_READ',
  },
  {
    path: '/category/workflow-management',
    component: WorkflowManagement,
    name: 'WORKFLOW_MANAGEMENT',
  },

  // PARTNER
  {
    path: '/partner/add-partner',
    component: AddPartner,
    name: 'PARTNER_CREATE',
  },
  {
    path: '/partner/manage-partner',
    component: ManagePartner,
    name: 'PARTNER_READ',
  },

  // FACILITY
  {
    path: '/facility/add-location',
    component: AddLocation,
    name: `FACILITY_CREATE`,
  },
  {
    path: '/facility/manage-location',
    component: ManageLocation,
    name: `FACILITY_READ`,
  },
  {
    path: '/facility/blocked-date',
    component: LocationBlockDateManagement,
    name: `FACILITY_BLOCKED_DATES`,
  },

  // SERVICE
  {
    path: '/service/add-service',
    component: AddService,
    name: `SERVICE_CREATE`,
  },
  {
    path: '/service/manage-service',
    component: ManageService,
    name: `SERVICE_READ`,
  },
  {
    path: '/service/blocked-date',
    component: ServiceBlockDateManagement,
    name: `SERVICE_BLOCKED_DATES`,
  },

  // UPLOAD STATUS
  {
    path: '/supply-store/upload-status',
    component: UploadStatus,
    name: 'UPLOAD_FILE',
  },

  // MASTER UPLOAD
  {
    path: '/supply-store/master-upload',
    component: MasterUploads,
    name: 'SUPPLY_DATA_GM_REPORT',
  },

  /* ----------------------------------- CONFIG STORE MANAGEMENT ----------------------------------- */
  // BENEFIT CONFIG
  {
    path: '/config-store/benefit-config',
    component: CatalogueManagement,
    name: `BENEFIT_CONFIG`,
  },

  /* ----------------------------------- COUPON MANAGEMENT ----------------------------------- */
  {
    path: '/coupons/unique-coupons',
    component: UniqueCouponManagement,
    name: 'UNQIUE_COUPON',
  },

  {
    path: '/coupons/static-coupons',
    component: StaticCouponManagement,
    name: 'STATIC_COUPON',
  },

  /* ----------------------------------- CUSTOMER MANAGEMENT ----------------------------------- */
  {
    path: '/customer-management',
    component: CustomerManagement,
    name: `CUSTOMER_MANAGEMENT`,
  },

  /* ----------------------------------- CUSTOMER DATA MANAGEMENT ----------------------------------- */
  {
    path: '/customer-data',
    component: CustomerDataManagement,
    name: `CUSTOMER_DATA_MANAGEMENT`,
  },

  /* ----------------------------------- DUPLICATE CARDS MANAGEMENT ----------------------------------- */
  {
    path: '/duplicate-cards',
    component: DuplicateCardsManagement,
    name: `DUPLICATE_CARDS_MANAGEMENT`,
  },

  /* ----------------------------------- SURGE SPHERE MANAGEMENT ----------------------------------- */
  // WALLET
  {
    path: '/surge-sphere/wallet',
    component: Wallet,
    name: `WALLET`,
  },

  // LEDGER
  {
    path: '/surge-sphere/ledger',
    component: Ledger,
    name: `LEDGER`,
  },

  // RULES
  {
    path: '/surge-sphere/rules',
    component: Rules,
    name: `RULES`,
  },

  // CAMPAIGNS
  {
    path: '/surge-sphere/campaigns',
    component: Campaigns,
    name: `CAMPAIGNS`,
  },

  // EVENTS
  {
    path: '/surge-sphere/events',
    component: Events,
    name: `EVENTS`,
  },

  // COMMUNICATION MANAGEMENT
  {
    path: '/surge-sphere/communication',
    component: Communication,
    name: `COMMUNICATION_MANAGEMENT`,
  },

  // GAMIFICATION
  {
    path: '/gamification',
    component: Gamification,
    name: `GAMIFICATION`,
  },

  // FEEDBACK
  {
    path: '/feedback',
    component: FeedbackGlobeToyota,
    name: `FEEDBACK_GLOBE_TOYOTA`,
  },

  // USER REGISTRATION
  {
    path: '/file-upload',
    component: FileUpload,
    name: `FILE_UPLOAD_V1`,
  },

  /* ----------------------------------- CUSTOM REPORT MANAGEMENT ----------------------------------- */
  {
    path: '/custom-reports',
    component: CustomDownload,
    name: `CUSTOM_REPORT_MANAGEMENT`,
  },

  // DATA POOL
  {
    path: '/data-pool',
    component: DataPool,
    name: `DATA_POOL`,
  },

  /* ----------------------------------- BENEFIT MANAGEMENT ----------------------------------- */
  // BENEFIT PACK
  {
    path: '/benefit-pack',
    component: BenefitPacksManagement,
    name: `BENEFIT_PACK`,
  },

  // BENEFIT GROUP
  {
    path: '/benefit-groups',
    component: BenefitGroupsManagement,
    name: `BENEFIT_GROUP`,
  },

  /* ----------------------------------- BOOKING MANAGEMENT ----------------------------------- */
  // STATIC COUPON BOOKING
  {
    path: '/bookings/static-coupon',
    component: StaticCouponBookingManagement,
    name: `STATIC_COUPON_BOOKING_READ`,
  },

  // UNIQUE COUPON BOOKING
  {
    path: '/bookings/unique-coupon',
    component: UniqueCouponBookingManagement,
    name: `UNIQUE_COUPON_BOOKING_READ`,
  },

  // UNIQUE COUPON BOOKING
  {
    path: '/bookings/unique-coupon',
    component: UniqueCouponBookingManagement,
    name: `UNIQUE_COUPON_BOOKING_READ`,
  },

  // DELAYED COUPON BOOKING
  {
    path: '/bookings/delayed-coupon',
    component: DelayedCouponBookingManagement,
    name: `DELAYED_COUPON_BOOKING_READ`,
  },

  // GOLF BOOKING
  {
    path: '/bookings/golf',
    component: GolfBookingManagement,
    name: `GOLF_BOOKING_READ`,
  },

  {
    path: '/vendor/booking/dining',
    component: VendorDiningBooking,
    name: `DINING_BOOKING_MANAGEMENT`,
  },

  // DYNAMIC COUPON BOOKING
  {
    path: '/bookings/dynamic-coupon',
    component: DynamicCouponBookingManagement,
    name: `DYNAMIC_COUPON_BOOKING_READ`,
  },

  // INSURANCE BOOKING
  {
    path: '/bookings/insurance',
    component: InsuranceBookingManagement,
    name: `INSURANCE_BOOKING_READ`,
  },

  // LOCAL COURIER BOOKING
  {
    path: '/bookings/local-courier',
    component: LocalCourierBookingManagement,
    name: `LOCAL_COURIER_BOOKING_READ`,
  },

  // MEET & GREET BOOKING
  {
    path: '/bookings/meet-greet',
    component: MeetAndGreetBookingManagement,
    name: `MEET_AND_GREET_BOOKING_READ`,
  },

  // AIRPORT TRANSFER BOOKING
  {
    path: '/bookings/pick-drop',
    component: PickAndDropBookingManagement,
    name: `PICKUP_AND_DROP_BOOKING_READ`,
  },

  // QR BOOKING
  {
    path: '/bookings/qr',
    component: QRBookingManagement,
    name: `QR_BOOKING_READ`,
  },

  // CARTERX BOOKING
  {
    path: '/bookings/carterx',
    component: CarterXBooking,
    name: `CARTERX_BOOKING_READ`,
  },

  // CAR SERVICING BOOKING
  {
    path: '/bookings/car-servicing',
    component: CarServicingBookingManagement,
    name: `CAR_SERVICING_BOOKING_READ`,
  },

  // CAR REGISTRATION BOOKING
  {
    path: '/bookings/car-registration',
    component: CarRegistrationBookingManagement,
    name: `CAR_REGISTRATION_BOOKING_READ`,
  },

  // HIRE A DRIVER BOOKING
  {
    path: '/bookings/hire-a-driver',
    component: HireADriverBookingManagement,
    name: `HIRE_A_DRIVER_BOOKING_READ`,
  },

  // THRIWE PRIME BOOKING
  {
    path: '/bookings/thriwe-prime',
    component: ThriwePrimeBooking,
    name: `THRIWE_PRIME_BOOKING_READ`,
  },

  // DYNAMIC QR BOOKING
  {
    path: '/bookings/dynamic-qr-booking',
    component: DynamicQrBooking,
    name: `DYNAMIC_QR_BOOKING_READ`,
  },

  // CLUB BOOKING
  {
    path: '/bookings/club',
    component: ClubBookingManagement,
    name: `CLUB_BOOKING_READ`,
  },

  // DINING BOOKING
  {
    path: '/bookings/dining',
    component: DiningBooking,
    name: `OUTLET_BOOKING_READ`,
  },

  // DINING BOOKING
  {
    path: '/vendor/booking/dining',
    component: VendorDiningBooking,
    name: `DINING_BOOKING_MANAGEMENT`,
  },

  /* ---------------------------- INVENTORY SETTINGS ---------------------------- */
  {
    path: '/settings/airport-transfer',
    component: AirportTransfer,
    name: `AIRPORT_TRANSFER`,
  },

  /* ----------------------------------- DOWNLOAD ----------------------------------- */
  { path: '/downloads', component: Downloads, name: `DOWNLOAD_ACCESS` },

  {
    path: '/customer-downloads',
    component: CustomerDownloads,
    name: [
      `HSBC_BEACH_CLUB`,
      `ALRAJHI_GOLF`,
      `GLOBE_TOYOTA`,
      `ENBD_NATIONAL_DAY`,
      `MASTERCARD_FAB`,
      `THRIWE_APP`,
      `MASTERCARD_CL`,
      `HDFC_BUNDLE`,
      'ALRAJHI_VALET',
      'ENBD_VALET',
      'SAB_LANDMARK',
      `RIYADH_MUNICIPALITY`,
      'CBD_GOLF_V2',
      'VISA_PVT',
      'MASTERCARD_UAE',
      'MASTERCARD_AIR_DINE',
      'MASHREQ',
      'EIB_V2',
      'SCB_V1',
      'HSBC_GOLFPASS',
      'HSBC_BENEFITS',
      'EIB',
      'CBD_GOLF_NEW',
      'MASTERCARD_KSA',
      'SCB',
      'VISA_ONE_V1',
      'THRIWE_VALET_PARKING',
      'ADIB_V2',
      'ICICI_V1',
      'RAK_BANK',
      'CEO_MASTERS_2026',
      'ABUNDUNS',
      'INCRED',
      'NBF',
    ].includes(Constant.PROJECT_CODE)
      ? `DOWNLOAD_ACCESS`
      : ``,
  },

  /* ----------------------------------- RULES MANAGEMENT ----------------------------------- */
  // EXPENDITURES
  {
    path: '/rules/expenditure',
    component: ExpenditureManagement,
    name: `EXPENDITURE_READ`,
  },

  // EVENTS
  { path: '/rules/event', component: EventManagement, name: `EVENT_READ` },

  // SERVICES
  {
    path: '/rules/service',
    component: ServiceWorthManagement,
    name: `ASSIGN_COINS`,
  },

  /* ----------------------------------- GOLF ADMIN MANAGEMENT ----------------------------------- */
  // COURSE WISE FORMATS
  {
    path: '/golf/course-wise-formats',
    component: CourseWiseFormats,
    name: `GOLF_ADMIN_MANAGEMENT`,
  },

  // EDIT COURSE FORMATS
  {
    path: '/golf/edit-course-formats',
    component: EditCourseFormats,
    name: `GOLF_ADMIN_MANAGEMENT`,
  },

  // REAL TIME SLOTS REPORT
  {
    path: '/golf/real-time-slots-report',
    component: RealTimeSlotsReport,
    name: `GOLF_ADMIN_MANAGEMENT`,
  },

  // SLOTS UNAVAILABILITY
  {
    path: '/golf/slots-unavailability',
    component: SlotUnavailability,
    name: `GOLF_ADMIN_MANAGEMENT`,
  },

  /* ----------------------------------- USER MANAGEMENT ----------------------------------- */
  {
    path: '/user-management',
    component: UserManagement,
    name: `ADD_USER_PERMISSION`,
  },

  /* ----------------------------------- PROJECT MANAGEMENT ----------------------------------- */
  // CLIENTS
  {
    path: '/clients',
    component: Clients,
    name: `CLIENTS`,
  },

  // PLATFORM
  {
    path: '/platform/config',
    component: Platform,
    name: `ALL_PLATFORMS`,
  },

  // PROGRAMS
  {
    path: '/program/config',
    component: Program,
    name: `ALL_PROGRAMS`,
  },

  // DATA INTEGRATION
  {
    path: '/project/data-integration',
    component: DataIntegration,
    name: `DATA_INTEGRATION`,
  },

  // COMMUNICATION SETTINGS
  {
    path: '/project/comm-settings',
    component: ProjectComs,
    name: `COMMS_SETTINGS`,
  },

  // PROJECT ONBOARDING
  {
    path: '/project/project-onboarding',
    component: ProgramOnboarding,
    name: `PROGRAM_ONBOARDING`,
  },

  // PAYMENT SETTINGS
  {
    path: '/payment/settings',
    component: ProjectPaymentsSettings,
    name: `PROJECT_PAYMENTS`,
  },

  // PAYMENT LOGS
  {
    path: '/payments/logs',
    component: PaymentLogs,
    name: `PAYMENT_LOGS`,
  },

  /* ----------------------------------- REPORTS MANAGEMENT ----------------------------------- */
  // COMMS REPORT
  {
    path: '/comms-report',
    component: CommsReport,
    name: `COMMS_REPORTS`,
  },

  /* ----------------------------------- CLIENT PANEL ----------------------------------- */
  // CLIENT AIRPORT TRANSFER
  {
    path: '/client/airport-transfer',
    component: AirportTransferManualBooking,
    name: `CLIENT_AIRPORT_TRANSFER`,
  },

  // CLIENT AIRPORT MEET & GREET
  {
    path: '/client/airport-meet-greet',
    component: MeetAndGreetManualBooking,
    name: `CLIENT_AIRPORT_MEET_AND_GREET`,
  },

  // CLIENT HISTORY
  {
    path: '/client/history',
    component: History,
    name: `CLIENT_HISTORY`,
  },

  // CLIENT CONTACT
  {
    path: '/client/contact',
    component: ContactUs,
    name: `CLIENT_CONTACT`,
  },

  // CLIENT DOWNLOAD
  {
    path: '/client/downloads',
    component: ClientDownloads,
    name: `CLIENT_DOWNLOAD_DUMP`,
  },

  /* ----------------------------------- VENDOR PANEL ----------------------------------- */
  // VENDOR DASHBOARD
  {
    path: '/vendor/dashboard',
    component: VendorPanelDashboard,
    name: `VENDOR_DASHBOARD`,
  },

  // VENDOR DUMP DOWNLOAD
  {
    path: '/vendor/download',
    component: VendorDownloads,
    name: `VENDOR_DOWNLOAD_DUMP`,
  },

  // VENDOR AIRPORT TRANSFER
  {
    path: '/vendor/booking/airport-transfer',
    component: VendorAirportTransfer,
    name: `VENDOR_AIRPORT_TRANSFER`,
  },

  // VENDOR VALET PARKING BOOKING
  {
    path: '/vendor/booking/valet-parking',
    component: VendorBookingValetParking,
    name: `VENDOR_VALET_PARKING`,
  },

  // VENDOR VALET PARKING QR
  {
    path: '/vendor/qr',
    component: QRPage,
    name: `VENDOR_QR`,
  },

  // VENDOR REPORT
  {
    path: '/vendor/report',
    component: VendorReport,
    name: `VENDOR_REPORT`,
  },
  /* ----------------------------------- GM REPORT ----------------------------------- */
  // CLIENT PRICING
  {
    path: '/client-pricing',
    component: ClientPricing,
    name: `CLIENT_DATA_GM_REPORT`,
  },

  // PRICE VIEWER
  {
    path: '/price-viewer',
    component: PriceViewer,
    name: `PRICE_VIEWER_GM_REPORT`,
  },

  // BOOKING RECON
  {
    path: '/booking-recon',
    component: BookingRecon,
    name: `BOOKING_RECON_GM_REPORT`,
  },

  // GM REPORT
  {
    path: '/gm-report',
    component: GmReport,
    name: `MASTER_GM_REPORT`,
    // VENDOR VALET PARKING BOOKING
  },
  {
    path: '/vendor/booking/valet-parking',
    component: VendorBookingValetParking,
    name: `VENDOR_VALET_PARKING`,
  },

  // VENDOR VALET PARKING QR
  {
    path: '/vendor/qr',
    component: QRPage,
    name: `VENDOR_QR`,
  },

  // VENDOR REPORT
  {
    path: '/vendor/report',
    component: VendorReport,
    name: `VENDOR_REPORT`,
  },

  // VALET PARKING
  {
    path: '/bookings/valet-parking',
    component: ValetParkingManagement,
    name: `VALET_PARKING_BOOKING_READ`,
  },

  // CLIENT BUSINESS REGISTRATION
  {
    path: '/client/business-registration',
    component: BusinessRegistration,
    name: `ADIB_READ`,
  },

  // CLIENT POST
  {
    path: '/client/post',
    component: Posts,
    name: `ADIB_READ`,
  },

  // CLIENT ADIB_WRITE
  {
    path: '/client/offer',
    component: Offers,
    name: `ADIB_READ`,
  },

  // CLIENT ANNOUNCEMENT
  {
    path: '/client/announcements',
    component: Annoucements,
    name: `ADIB_READ`,
  },

  // CLIENT ADIB USERMANAGEMENT
  {
    path: '/user-management-adib',
    component: UserManagementAdib,
    name: `ADIB_SUPERADMIN`,
  },

  // USER DOWNLOADS
  {
    path: '/user-management-downloads',
    component: UserDownloads,
    name: `ADIB_SUPERADMIN`,
  },

  // CLIENT CUSTOMERS
  {
    path: '/client/customers',
    component: ClientCustomers,
    name: `ADIB_READ`,
  },

  // CLIENT GOLF BOOKINGS
  {
    path: '/client/delayed-bookings',
    component: ClientGolfBooking,
    name: `ADIB_READ`,
  },

  // CLIENT UNIQUE COUPON BOOKINGS
  {
    path: '/client/unique-coupon-bookings',
    component: ClientUniqueCouponBooking,
    name: `CLIENT_UNIQUE_COUPON_BOOKINGS`,
  },

  // CLIENT BOOKINGS DOWNLOAD
  {
    path: '/client/bookings/downloads',
    component: ClientBookingsDownloads,
    name: Constant.PROJECT_CODE === 'ADIB_V2' ? `ADIB_DOWNLOAD` : `CLIENT_BOOKINGS_DOWNLOAD_DUMP`,
  },

  /* ----------------------------------- BOOKING MANAGEMENT V2----------------------------------- */
  // DELAYED BOOKING V2
  {
    path: '/bookings/delayed-booking-v2',
    component: DelayedBookingV2,
    name: `DELAYED_BOOKING_V2_READ`,
  },

  // UNIQUE COUPON V2
  {
    path: '/bookings/unique-booking-v2',
    component: UniqueCouponV2,
    name: `UNIQUE_BOOKING_V2_READ`,
  },

  // STATIC COUPON V2
  {
    path: '/bookings/static-booking-v2',
    component: StaticCouponV2,
    name: `STATIC_BOOKING_V2_READ`,
  },

  // GOLF BOOKING V2
  {
    path: '/bookings/golf-v2',
    component: GolfBookingManagementV2,
    name: `GOLF_BOOKING_V2_READ`,
  },

  // AIRPORT TRANSFER BOOKING
  {
    path: '/bookings/pick-drop-v2',
    component: PickAndDropBookingManagementV2,
    name: `PICKUP_AND_DROP_BOOKING_V2_READ`,
  },

  // QR BOOKING
  {
    path: '/bookings/qr-v2',
    component: QRBookingManagementV2,
    name: `QR_BOOKING_V2_READ`,
  },

  // CUSTOM DELAYED BOOKING
  {
    path: '/bookings/custom-delayed-booking-v2',
    component: CustomDelayedBookingV2,
    name: `CUSTOM_DELAYED_V2_READ`,
  },

  // DYNAMIC BOOKING
  {
    path: '/bookings/dynamic-booking-v2',
    component: DynamicCouponV2,
    name: `DYNAMIC_COUPON_V2_READ`,
  },

  // PADDLE BOOKING
  {
    path: '/bookings/paddle-booking',
    component: PaddleBooking,
    name: `PADDLE_BOOKING_V2_READ`,
  },

  // VASCO BOOKING
  {
    path: '/bookings/vasco-booking',
    component: VascoBooking,
    name: `VISA_APPLICATION_BOOKING_V2_READ`,
  },

  // VALET BOOKING
  {
    path: '/bookings/valet-booking',
    component: ValetBooking,
    name: `VALET_BOOKING_V2_READ`,
  },

  /* ----------------------------------- REVIEW----------------------------------- */
  // FEEDBACK
  {
    path: '/review/feedback',
    component: Feedback,
    name: `FEEDBACK`,
  },

  {
    path: '/review/query',
    component: Query,
    name: `QUERY`,
  },

  /* ----------------------------------- BOOKING SEARCH ----------------------------------- */

  {
    path: '/booking-search',
    component: BookingSearch,
    name: `BOOKING_COUPON_ENQUIRY_READ`,
  },

  // GM REPORT
  {
    path: '/bookings/valet-parking',
    component: ValetParkingManagement,
    name: `VALET_PARKING_BOOKING_READ`,
  },

  /* ----------------------------------- SURGE MANAGEMENT ----------------------------------- */
  // SURGE DASHBOARD
  {
    path: '/surge/dashboard',
    component: SurgeDashboard,
    name: `SURGE_RULES_MANAGEMENT`,
  },

  // CREATE SURGE WORKFLOW
  {
    path: '/surge/workflow',
    component: SurgeWorkflow,
    name: `SURGE_EVENTS_MANAGEMENT`,
  },

  // LADIES CLUB BOOKING
  {
    path: '/bookings/ladies-club-booking',
    component: LadiesClubBooking,
    name: `LADIES_CLUB_BOOKING_V2_READ`,
  },

  // MEET GREET BOOKING
  {
    path: '/bookings/meet-greet-booking',
    component: MeetGreetBooking,
    name: `MEET_AND_GREET_BOOKING_V2_READ`,
  },

  // SURGE EVENTS
  {
    path: '/surge/templates',
    component: SurgeEvent,
    name: `SURGE_EVENTS_MANAGEMENT`,
  },

  // SURGE MAPPING
  {
    path: '/surge/mapping',
    component: ConfigurationMapping,
    name: `SURGE_EVENTS_MANAGEMENT`,
  },

  // SURGE RULES
  {
    path: '/surge/rule',
    component: RulesList,
    name: `SURGE_RULES_MANAGEMENT`,
  },

  // REFERRAL
  {
    path: '/referral',
    component: Referral,
    name: `REFERRAL`,
  },

  {
    path: '/ledger',
    component: LedgerV2,
    name: `LEDGER_LIST`,
  },

  {
    path: '/voucher',
    component: Voucher,
    name: `VOUCHER`,
  },

  {
    path: '/announcement',
    component: AnnoucementForGlobeToyota,
    name: `ANNOUNCEMENT_READ`,
  },

  // BOOKING DOWNLOADS
  {
    path: '/booking-downloads',
    component: BookingDownloads,
    name: `ADIB_DOWNLOAD`,
  },

  {
    path: '/bookings/client-unique-booking',
    component: ClientUniqueBooking,
    name: `CLIENT_UNIQUE_BOOKING_READ`,
  },

  {
    path: '/bookings/client-dynamic-booking',
    component: ClientDynamicBooking,
    name: `CLIENT_DYNAMIC_BOOKING_READ`,
  },

  {
    path: '/bookings/client-gamification-booking',
    component: ClientGamificationBooking,
    name: `CLIENT_GAMIFICATION_BOOKING_READ`,
  },

  {
    path: '/client-booking-downloads',
    component: ClientDownloadsV2,
    name: `CLIENT_DOWNLOAD_ACCESS`,
  },

  {
    path: '/client-customer-downloads',
    component: ClientCustomerDownloadsV2,
    name: `CLIENT_DOWNLOAD_ACCESS`,
  },

  {
    path: '/client-customer-management',
    component: ClientCustomerManagement,
    name: `CLIENT_DOWNLOAD_ACCESS`,
  },
];

/* Domain (host) specific overrides - see `domainConfig.js` */
const domainRoutes = applyDomainRouteAliases({ publicRoutes, authProtectedRoutes, authV2ProtectedRoutes });

const domainPublicRoutes = domainRoutes?.publicRoutes;
const domainAuthProtectedRoutes = domainRoutes?.authProtectedRoutes;
const domainAuthV2ProtectedRoutes = domainRoutes?.authV2ProtectedRoutes;

export { domainAuthProtectedRoutes as authProtectedRoutes, domainPublicRoutes as publicRoutes, domainAuthV2ProtectedRoutes as authV2ProtectedRoutes };
